module.exports = __webpack_public_path__ + "img/reset_pass1.26318c33.jpg";